import type { MassPerUnit } from "@/stores/project/types/enum";

// The mass-unit enum API (api/material/declaredmassunitenum) returns spelled-out
// names in DisplayName (e.g. "Kilograms per square meter"). The datasheet wants the
// compact ratio symbol ("kg/m²"). The Enum code is the stable key to map from;
// unknown codes ("Other") fall back to DisplayName so nothing regresses.
const MASS_UNIT_SYMBOLS: Partial<Record<MassPerUnit["Enum"], string>> = {
  KG_M: "kg/m",
  KG_M2: "kg/m²",
  KG_M3: "kg/m³",
  KG_PSC: "kg/pcs",
  KG_KG: "kg/kg",
  KG_DM3: "kg/dm³",
  T_M: "t/m",
  T_M2: "t/m²",
  T_M3: "t/m³",
  T_Psc: "t/pcs",
};

/**
 * Resolve a mass-per-declared-unit to its display symbol.
 * Returns the mapped ratio symbol (e.g. "kg/m²") when the Enum code is known,
 * otherwise falls back to the backend DisplayName, and finally to an empty string.
 */
export function massUnitSymbol(unit: Pick<MassPerUnit, "Enum" | "DisplayName"> | undefined | null): string {
  if (!unit) return "";
  return MASS_UNIT_SYMBOLS[unit.Enum] ?? unit.DisplayName ?? "";
}
